/**
 * 관리자 사이드바 스토어 팝오버 — 장비불러·머큐리·악덕알리미 앱 스토어 주소.
 *
 *   마크업: layouts/main.blade.php 의 #admStoreBtn(버튼) · #admStorePop(팝오버, 주소는 g5_apps)
 *   스타일: sass/admin/components/_store-links.scss
 *
 * 누르면 열고 닫는다. **마우스가 있는 기기는 올리기만 해도** 열리고, 버튼·팝오버 밖으로
 * 나가면 잠깐 뒤 닫힌다 — 버튼에서 팝오버로 옮겨가는 틈에 닫히지 않게 지연을 둔다.
 *
 * PC 에서는 버튼을 누르기 전에 이미 hover 로 열려 있다. 그때 누른 것을 '닫기'로 받으면
 * 열려던 사람 손에서 판이 사라진다 → hover 로 열린 판을 누르면 **고정**(밖으로 나가도 유지)하고,
 * 고정된 판을 다시 누를 때만 닫는다. 고정된 판은 바깥 클릭·Esc 로 닫힌다.
 *
 * $j.Ui.Tooltip 의 hover 모드를 쓰지 않는 이유: 그 모드는 팝오버가 마우스를 통과시킨다
 * (pointer-events:none). 안의 링크를 눌러야 하는 이 판에는 맞지 않는다.
 *
 * 팝오버는 사이드바 밖(body 쪽)에 있다. 사이드바가 overflow 로 자르기 때문에 버튼 옆에
 * fixed 로 붙인다.
 */
const CLOSE_DELAY = 180;   // 버튼 → 팝오버로 마우스를 옮기는 틈

export default class StoreLinks {
    constructor() {
        this.$btn = null;
        this.$pop = null;
        this._timer = null;
        this._pinned = false;   // 클릭으로 연(고정한) 판 — 마우스가 나가도 닫지 않는다
        $(() => this.init());
    }

    init() {
        this.$btn = $('#admStoreBtn');
        this.$pop = $('#admStorePop');
        if (!this.$btn.length || !this.$pop.length) return;

        this.$btn.on('click', (e) => {
            e.stopPropagation();
            if (this.isOpen() && this._pinned) { this.close(); return; }
            this._cancelClose();
            this.open();
            this._pinned = true;
        });

        // 마우스가 있는 기기만 — 터치에서 mouseenter 가 탭과 같이 나면 열자마자 click 이 닫는다
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
            this.$btn.add(this.$pop)
                .on('mouseenter', () => { this._cancelClose(); this.open(); })
                .on('mouseleave', () => this._closeLater());
        }

        // 링크를 누르면 새 창이 뜨니 판은 닫는다
        this.$pop.on('click', 'a', () => this.close());
        $(document).on('click', (e) => {
            if (this.isOpen() && !$(e.target).closest('#admStorePop').length) this.close();
        });
        $(document).on('keydown', (e) => { if (e.key === 'Escape') this.close(); });
        $(window).on('resize scroll', () => { if (this.isOpen()) this._place(); });
    }

    isOpen() {
        return this.$pop && !this.$pop.prop('hidden');
    }

    open() {
        if (this.isOpen()) return;
        this.$pop.prop('hidden', false);
        this._place();
        this.$btn.attr('aria-expanded', 'true').addClass('is-open');
    }

    close() {
        this._cancelClose();
        this._pinned = false;
        if (!this.isOpen()) return;
        this.$pop.prop('hidden', true);
        this.$btn.attr('aria-expanded', 'false').removeClass('is-open');
    }

    /** 버튼 오른쪽, 위쪽 맞춤. 화면 아래로 넘치면 위로 올린다 */
    _place() {
        const r = this.$btn[0].getBoundingClientRect();
        const h = this.$pop.outerHeight();
        const top = Math.max(8, Math.min(r.top, window.innerHeight - h - 8));
        this.$pop.css({ left: Math.round(r.right + 10) + 'px', top: Math.round(top) + 'px' });
    }

    _closeLater() {
        this._cancelClose();
        if (this._pinned) return;
        this._timer = setTimeout(() => this.close(), CLOSE_DELAY);
    }

    _cancelClose() {
        if (this._timer) { clearTimeout(this._timer); this._timer = null; }
    }
}
